import { InjectionToken } from '@angular/core';
import { JSONSchema7 } from 'json-schema';
import { AbstractFormComponent } from './app/cms/slices/slice-forms/abstract-form-component';

export const VALIDATION_SCHEMA_CONFIG = new InjectionToken<JSONSchema7>('VALIDATION_SCHEMA_CONFIG');

export const FORM_COMPONENT = new InjectionToken<AbstractFormComponent>('FORM_COMPONENT');
